import Svg, { Path } from 'react-native-svg';

/** 콘텐츠 카드 우상단 영상 표시자 (Figma `icon_inform` / Exclude) */
export const IconPlayBadge = () => (
  <Svg width={24} height={24} viewBox="0 0 22.5 22.5" fill="none">
    <Path
      d="M16.2 3C18.0225 3 19.5 4.47746 19.5 6.3V16.2C19.5 18.0225 18.0225 19.5 16.2 19.5H6.3C4.47746 19.5 3 18.0225 3 16.2V6.3C3 4.47746 4.47746 3 6.3 3H16.2ZM10.0608 7.11453C9.51287 6.74563 8.775 7.13871 8.775 7.79934V14.7007C8.775 15.3613 9.51287 15.7544 10.0608 15.3855L15.1841 11.934C15.6695 11.607 15.6695 10.893 15.1841 10.566L10.0608 7.11453Z"
      fill={'white'}
    />
  </Svg>
);
